import React, { useState } from "react";
import { toast } from "sonner";
import { useSettings } from "../context/SettingsContext";
import { buildWhatsappLink } from "../lib/analytics";
import { MessageCircle, Mail, Phone } from "lucide-react";

export default function Contact() {
    const { settings } = useSettings();
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    React.useEffect(() => { document.title = "Contact | Loomara"; }, []);

    const submit = (e) => {
        e.preventDefault();
        toast("Thank you — we'll be in touch soon.");
        setForm({ name: "", email: "", message: "" });
    };

    const waLink = buildWhatsappLink({
        number: settings?.whatsappNumber || "919999999999",
        template: "Hi Loomara, I have a question about my order / collection.",
        product: { name: "your collection" },
    });

    return (
        <div className="container-boutique py-16 lg:py-24 grid md:grid-cols-2 gap-12" data-testid="contact-page">
            <div>
                <p className="eyebrow">Say Hello</p>
                <h1 className="font-serif text-5xl text-ink-900 mt-3 leading-tight">We'd love to <span className="italic text-sage-600">hear from you</span>.</h1>
                <p className="text-ink-700 mt-5 leading-relaxed max-w-md">
                    Questions about sizing, fabric, or finding the perfect gift? Our boutique team replies within 24 hours.
                </p>

                <div className="mt-8 space-y-3 text-sm text-ink-700">
                    <p className="flex items-center gap-3"><Mail size={16} className="text-sage-600" /> hello@loomarakids.in</p>
                    <p className="flex items-center gap-3"><Phone size={16} className="text-sage-600" /> +91 99999 99999</p>
                    <a href={waLink} target="_blank" rel="noreferrer" className="btn-whatsapp mt-3" data-testid="contact-whatsapp-btn">
                        <MessageCircle size={14} /> Chat on WhatsApp
                    </a>
                </div>
            </div>

            <form onSubmit={submit} className="card-soft p-8" data-testid="contact-form">
                <h2 className="font-serif text-3xl text-ink-900 mb-6">Send a message</h2>
                <div className="space-y-4">
                    <input value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} required placeholder="Your name" className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sage-300 border border-sage-300/30" data-testid="contact-name" />
                    <input value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} required type="email" placeholder="Email" className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sage-300 border border-sage-300/30" data-testid="contact-email" />
                    <textarea value={form.message} onChange={(e)=>setForm({...form, message: e.target.value})} required rows={5} placeholder="How can we help?" className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sage-300 border border-sage-300/30" data-testid="contact-message" />
                    <button className="btn-primary w-full" data-testid="contact-submit">Send Message</button>
                </div>
            </form>
        </div>
    );
}
